import PropTypes from 'prop-types';

export const StepItem = PropTypes.shape({
  label: PropTypes.string,
  nextPath: PropTypes.string,
  path: PropTypes.string,
});

export const Location = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string,
  hash: PropTypes.string,
});
